import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DialogBelonging } from '@costlydeveloper/ngx-awesome-popup';
import { Subscription } from 'rxjs';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'app-dialog-clean-cart',
  templateUrl: './dialog-clean-cart.component.html',
  styleUrls: ['./dialog-clean-cart.component.scss']
})
export class DialogCleanCartComponent {

  private subscriptions: Subscription = new Subscription();
  loading = false;

  constructor(private cartService: CartService, @Inject('dialogBelonging') public dialogBelonging: DialogBelonging, private router: Router) { }

  ngOnInit() {
    this.subscriptions.add(
      this.dialogBelonging.eventsController.onButtonClick$.subscribe((_Button) => {
        if (_Button.ID === 'submit') {
          // El botón sigue activo mientras gira el spinner: sin esto, un segundo clic vacía dos veces.
          if (this.loading) return;
          this.loading = true;
          this.cartService.emptyCart().subscribe(() => {
            this.cartService.getCart().subscribe(() => {
              this.loading = false;
              this.dialogBelonging.eventsController.close();
            });
          });
        } else if (_Button.ID === 'cancel' && !this.loading) {
          this.dialogBelonging.eventsController.close();
        }
      })
    );
  }

  ngOnDestroy(): void {
    // Care about memory and close all subscriptions.
    this.subscriptions.unsubscribe();
  }

}
